module.exports = __webpack_public_path__ + "img/zyava.5e21fd01.jpeg";